import linegraph from "../../components/linegraph.vue"
import * as echarts from "echarts"
import '../../utils/flexible'
import { fontChart } from '../../utils/echartPxToRem'
import '../../utils/rem'
import moment from "moment";
import screenfull from "screenfull";

export default {
  name: "HomePage",
  components: { linegraph },
  data() {
    return {
      carCount: '',
      internalCombustionCarCount: '',
      electricCarCount: '',
      newRegulationsCount: '',
      workDayCount: '',
      workTimeSum: '',

      isTrial: true,
      trialLoading: false,
      trialOption: {},
      normalCount: '',
      approachCount: '',
      expirationCount: '',

      isAge: true,
      ageLoading: false,
      ageOption: {},

      isCapacity: true,
      capacityLoading: false,
      capacityOption: {},

      isMap: true,
      mapLoading: false,
      data: [],
      btnList: [
        { name: this.$t('VehicleAnalysis.annualAudit')  },
        { name: this.$t('VehicleAnalysis.compliance')  },
        { name: this.$t('VehicleAnalysis.insurance')  }
      ],
      changeBackground: 0,
      selectType: 0,

      weather: {},
      date: '',
      time: '',

      isInsure: true,
      insureLoading: false,
      insureOption: {},
      newRegulationsCount: '',
      noNewRegulationsCount: '',

      isNewRule: true,
      newRuleLoading: false,
      newRuleOption: {},
      insureNormalCount: '',
      insureApproachCount: '',
      insureExpirationCount: '',

      isCarRate: true,
      carRateLoading: false,
      carRateOption: {},

      isCheck: true,
      checkLoading: false,
      checkOption: {},

      iFullScreen: false,
    };
  },
  created() {
  },
  mounted() {
    let _this = this;
    this.timer = setInterval(() => {
      _this.date = moment().format("YYYY年MM月DD日 HH:mm:ss"); 
    }, 100)
    this.getValue()
    this.getAge()
    this.getCapacity()
    this.getCarRate()
    this.getCheck()
    this.getMapData()
    this.getWeather()
    window.addEventListener('resize', () => {
      this.getValue()
      this.getAge()
      this.getCapacity()
      this.getCarRate()
      this.getCheck()
      this.getMap(this.data)
    })
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener('resize', () => {
      this.getValue()
      this.getAge()
      this.getCapacity()
      this.getCarRate()
      this.getCheck()
      this.getMap(this.data)
    })
  },
  methods: {
    btnSys() {
      this.$router.push('/VehicleManagement/VehicleStatus')
    },
    toggleFullScreen() {
      if (screenfull.isEnabled) {
        if (!screenfull.isFullscreen) {
          this.iFullScreen = !this.iFullScreen;
          screenfull.request();
        } else {
          this.iFullScreen = !this.iFullScreen;
          screenfull.exit();
        }
      } else {
        this.$message({ message: this.$t('VehicleAnalysis.form.yourBrowserDoesNotSupportFullScreen') , type: "warning" });
      }
    },

    getValue() {
      let param = {
        orgId: sessionStorage.getItem('roleData')
      }
      this.$store.dispatch('HomePage/GET_GETSTATISTICALDATA', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.carCount = res.data.data.carCount
            this.internalCombustionCarCount = res.data.data.internalCombustionCarCount
            this.electricCarCount = res.data.data.electricCarCount
            this.newRegulationsCount = res.data.data.newRegulationsCount
            this.workDayCount = res.data.data.workDayCount
            this.workTimeSum = res.data.data.workTimeSum
            this.normalCount = res.data.data.normalCount
            this.approachCount = res.data.data.approachCount
            this.expirationCount = res.data.data.expirationCount
            this.trial(this.normalCount, this.approachCount, this.expirationCount)
            this.newRegulationsCount = res.data.data.newRegulationsCount
            this.noNewRegulationsCount = res.data.data.noNewRegulationsCount
            this.insure(this.newRegulationsCount, this.noNewRegulationsCount)
            this.insureNormalCount = res.data.data.insureNormalCount
            this.insureApproachCount = res.data.data.insureApproachCount
            this.insureExpirationCount = res.data.data.insureExpirationCount
            this.newRule(this.insureNormalCount, this.insureApproachCount, this.insureExpirationCount)
          }
        }
      }).catch(err => { })
    },
    getWeather() {
      this.$axios.get('https://v0.yiketianqi.com/api?unescape=1&version=v62&appid=72745328&appsecret=5mwMNkT1&cityid=101020800', {
      }).then(res => {
        console.log(res.data);
        if (res.data) {
          this.weather = res.data
        }
      }).catch(err => {
        
      })
    },

    trial(normalCount, approachCount, expirationCount) {
      var dataStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          shadowBlur: 0,
          shadowColor: '#203665'
        }
      };
      let data = Number(normalCount + approachCount + expirationCount)
      let option = {
        title: [{
          text: this.$t('common.normal'),
          top: '86%',
          left: '15%',
          textAlign: 'center',
          textStyle: {
            color: '#F9FCFF',
            fontSize: fontChart(16),
          },
        },
        {
          text: this.$t('common.nearTime'),
          top: '86%',
          left: '50%',
          textAlign: 'center',
          textStyle: {
            color: '#F9FCFF',
            fontSize: fontChart(16),
          },
        },
        {
          text: this.$t('VehicleAnalysis.exceedTime') ,
          top: '86%',
          left: '85%',
          textAlign: 'center',
          textStyle: {
            color: '#F9FCFF',
            fontSize: fontChart(16),
          },
        }],
        series: [{
          name: this.$t('VehicleAnalysis.innerRing') ,
          type: 'pie',
          silent: true,
          clockwise: true,
          radius: ['40%', '41%'],
          center: ['15%', '45%'],
          label: {
            show: false,
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            color: 'rgba(0, 106, 250, .3)',
          },
          data: [0]
        }, {
          name: this.$t('common.normal'),
          type: 'pie',
          clockWise: false,
          radius: ['50%', '66%'],
          itemStyle: dataStyle,
          hoverAnimation: false,
          center: ['15%', '45%'],
          data: [{
            value: normalCount,
            label: {
              normal: {
                formatter: "{d}%",
                position: 'center',
                show: true,
                textStyle: {
                  fontSize: fontChart(18),
                  fontWeight: 'normal',
                  color: '#F9FCFF'
                }
              }
            },
            itemStyle: {
              normal: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#01EAFF",
                  },
                  {
                    offset: 1,
                    color: "#006AFA",
                  },
                ]),
              }
            }
          }, {
            value: data - Number(normalCount),
            name: 'invisible',
            itemStyle: {
              normal: {
                color: 'rgba(13, 106, 232, .3)'
              },
              emphasis: {
                color: 'rgba(13, 106, 232, .3)'
              }
            }
          }]
        }, {
          name: this.$t('VehicleAnalysis.innerRing') ,
          type: 'pie',
          silent: true,
          clockwise: true,
          radius: ['40%', '41%'],
          center: ['50%', '45%'],
          label: {
            show: false,
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            color: 'rgba(0, 106, 250, .3)',
          },
          data: [0]
        }, {
          name: this.$t('common.nearTime'),
          type: 'pie',
          clockWise: false,
          radius: ['50%', '66%'],
          itemStyle: dataStyle,
          hoverAnimation: false,
          center: ['50%', '45%'],
          data: [{
            value: approachCount,
            label: {
              normal: {
                formatter: "{d}%",
                position: 'center',
                show: true,
                textStyle: {
                  fontSize: fontChart(18),
                  fontWeight: 'normal',
                  color: '#F9FCFF'
                }
              }
            },
            itemStyle: {
              normal: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#E8BC7B",
                  },
                  {
                    offset: 1,
                    color: "#E98E07",
                  },
                ]),
              }
            }
          }, {
            value: data - Number(approachCount),
            name: 'invisible',
            itemStyle: {
              normal: {
                color: 'rgba(13, 106, 232, .3)'
              },
              emphasis: {
                color: 'rgba(13, 106, 232, .3)'
              }
            }
          }]
        }, {
          name: this.$t('VehicleAnalysis.innerRing') ,
          type: 'pie',
          silent: true,
          clockwise: true,
          radius: ['40%', '41%'],
          center: ['85%', '45%'],
          label: {
            show: false,
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            color: 'rgba(0, 106, 250, .3)',
          },
          data: [0]
        }, {
          name: this.$t('common.exceedTime'),
          type: 'pie',
          clockWise: false,
          radius: ['50%', '66%'],
          itemStyle: dataStyle,
          hoverAnimation: false,
          center: ['85%', '45%'],
          data: [{
            value: expirationCount,
            label: {
              normal: {
                formatter: "{d}%",
                position: 'center',
                show: true,
                textStyle: {
                  fontSize: fontChart(18),
                  fontWeight: 'normal',
                  color: '#F9FCFF'
                }
              }
            },
            itemStyle: {
              normal: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#D96C77",
                  },
                  {
                    offset: 1,
                    color: "#D20619",
                  },
                ]),
              }
            }
          },
          {
            value: data - Number(expirationCount),
            name: 'invisible',
            itemStyle: {
              normal: {
                color: 'rgba(13, 106, 232, .3)'
              },
              emphasis: {
                color: 'rgba(13, 106, 232, .3)'
              }
            }
          }
          ]
        }]
      };
      this.trialOption = option
    },

    getAge() {
      let ageObj = {
        Data: [],
        Count: []
      }
      let param = {
        orgId: sessionStorage.getItem('roleData')
      }
      this.$store.dispatch('HomePage/GET_GETCARAGEPROPORTION', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            res.data.data.map(item => {
              ageObj.Data.push(item.carAge)
              ageObj.Count.push(item.carAgeRate)
            })
            this.age(ageObj)
          }
        }
      }).catch(err => { })
    },
    age(ageObj) {
      let option = {
        grid: {
          top: '10%',
          left: '12%',
          right: '3%',
          bottom: '14%'
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return params.name + this.$t('VehicleAnalysis.year') + "<br/>" + this.$t('VehicleAnalysis.carAgeRatio') + ' : ' + params.value
          }
        },
        xAxis: {
          type: 'category',
          axisTick: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#818A98"
            }
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontChart(16),
            },
          },
          data: ageObj.Data
        },
        yAxis: {
          type: 'value',
          axisTick: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            formatter: "{value} %",
            color: "#fff",
            fontSize: fontChart(16),
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(173,177,195,.1)"],
              type: "dashed",
            },
          },
        },
        series: [
          {
            data: ageObj.Count,
            type: "pictorialBar",
            symbol: "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#01EAFF" },
                  { offset: 1, color: "#006AFA" },
                ]),
              },
            },
          }
        ]
      };
      this.ageOption = option
    },

    getCapacity() {
      let capacityObj = {
        Data: [],
        Count: []
      }
      let param = {
        orgId: sessionStorage.getItem('roleData')
      }
      this.$store.dispatch('HomePage/GET_GETCARCAPACITYPROPORTION', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            res.data.data.map(item => {
              capacityObj.Data.push(item.capacityType)
              capacityObj.Count.push(item.capacityRate)
            })
            this.capacity(capacityObj)
          }
        }
      }).catch(err => { })
    },
    capacity(capacityObj) {
      let option = {
        grid: {
          top: '10%',
          left: '12%',
          right: '3%',
          bottom: '14%'
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return params.name + this.$t('VehicleAnalysis.year') + "<br/>" + this.$t('VehicleAnalysis.carryingCapacityStatistics') + ' : ' + params.value
          }
        },
        xAxis: {
          type: 'category',
          axisTick: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#818A98"
            }
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontChart(16),
            },
          },
          data: capacityObj.Data
        },
        yAxis: {
          type: 'value',
          axisTick: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            formatter: "{value} %",
            color: "#fff",
            fontSize: fontChart(16),
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(173,177,195,.1)"],
              type: "dashed",
            },
          },
        },
        series: [
          {
            data: capacityObj.Count,
            type: "bar",
            barWidth: '30%',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#01EAFF" },
                  { offset: 1, color: "#006AFA" },
                ]),
              },
            },
          }
        ]
      };
      this.capacityOption = option
    },

    insure(newRegulationsCount, noNewRegulationsCount) {
      let allValue = Number(newRegulationsCount + noNewRegulationsCount)
      let tableData = [{
        value: (newRegulationsCount * 100 / allValue).toFixed(2),
        name: this.$t('VehicleAnalysis.conform')
      }, {
        value: (noNewRegulationsCount * 100 / allValue).toFixed(2),
        name: this.$t('VehicleAnalysis.inconform')
      }]
      let option = {
        legend: {
          data: [this.$t('VehicleAnalysis.conform'), this.$t('VehicleAnalysis.inconform')],
          icon: "vertical",
          itemWidth: fontChart(16),
          itemHeight: fontChart(16),
          itemGap: fontChart(30),
          top: '5%',
          formatter: function (name) {
            let _arr = '';
            for (var i = 0; i < tableData.length; i++) {
              if (tableData[i].name == name) {
                _arr = '{b|' + name + '}' + '{a|' + tableData[i].value + '%' + '}';
              }
            }
            return _arr;
          },
          textStyle: {
            fontSize: fontChart(16),
            color: '#A8CCDE',
            padding: [2, 0],
            rich: {
              a: {
                color: '#F9FCFF',
                align: 'center',
                fontSize: fontChart(30),
                fontWeight: "bold"
              },
              b: {
                color: '#F9FCFF',
                align: 'center',
                fontSize: fontChart(16),
                padding: [0, 10, 0, 0]
              }
            },
          }
        },

        xAxis: {
          show: false,
          type: 'value',
        },
        yAxis: [
          {
            type: 'category',
            data: [''],
            axisLine: { show: false },
            axisTick: [{
              show: false
            }]
          }
        ],
        series: [
          {
            type: 'bar',
            name: tableData[0].name,
            stack: this.$t('VehicleAnalysis.total'),
            barWidth: fontChart(14),
            showBackground: true,
            backgroundStyle: {
              color: 'transparent',
            },
            data: [newRegulationsCount],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#64A2FA" },
                  { offset: 1, color: "#006AFA" },
                ]),
              },
            },
          },
          {
            type: 'bar',
            name: tableData[1].name,
            stack: this.$t('VehicleAnalysis.total'),
            barWidth: fontChart(14),
            showBackground: true,
            backgroundStyle: {
              color: 'transparent',
            },
            silent: true,
            data: [noNewRegulationsCount],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#82F5FF" },
                  { offset: 1, color: "#01EAFF" },
                ]),
              },
            },
          }
        ]
      };
      this.insureOption = option
    },

    newRule(insureNormalCount, insureApproachCount, insureExpirationCount) {
      let color1 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "#64A2FA" },
        { offset: 1, color: "#006AFA " },
      ])
      let color2 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "#E8BC7B" },
        { offset: 1, color: "#E98E07" },
      ])
      let color3 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "#D96C77" },
        { offset: 1, color: "#D20619" },
      ])
      let colorList = [color1, color2, color3];
      let chartData = [{ name: this.$t('common.normal'), value: insureNormalCount },
      { name: this.$t('common.nearTime'), value: insureApproachCount },
      { name: this.$t('common.exceedTime'), value: insureExpirationCount }]
      let option = {
        color: colorList,
        tooltip: {
          confine: true,
        },
        legend: {
          orient: 'vertical',
          icon: "vertical",
          left: '10%',
          top: 'center',
          itemWidth: fontChart(16),
          itemHeight: fontChart(16),
          itemGap: fontChart(10),
          formatter: function (name) {
            let _arr = '';
            for (var i = 0; i < chartData.length; i++) {
              if (chartData[i].name == name) {
                _arr = '{b|' + name + '}' + '{a|' + chartData[i].value + '}' + '{b|'+this.$t('HomPage.forklift')+'}';
              }
              
            }
            return _arr;
          },
          data: [this.$t('common.normal'), this.$t('common.nearTime'), this.$t('common.exceedTime')],
          textStyle: {
            fontSize: fontChart(16),
            color: '#A8CCDE',
            padding: [2, 0],
            rich: {
              a: {
                color: '#F9FCFF',
                align: 'center',
                fontSize: fontChart(24),
                padding: [0, 10]
              },
              b: {
                color: '#F9FCFF',
                align: 'center',
                fontSize: fontChart(16),
              }
            },
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['50%', '66%'],
            center: ['70%', '50%'],
            hoverAnimation: false,
            avoidLabelOverlap: false,
            label: {
              formatter: "{d}%",
              color: "#F9FCFF",
              fontSize: fontChart(16)
            },
            labelLine: {
              show: true,
              length: 0,
            },
            data: chartData,
          },
          {
            name: '',
            type: 'pie',
            radius: ['32%', '40%'],
            center: ['70%', '50%'],
            hoverAnimation: false,
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#071649',
              borderWidth: fontChart(2),
            },
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false,
            },
            data: chartData,
          },
        ],
      };
      this.newRuleOption = option
    },

    getCarRate() {
      let carRateObj = {
        Data: [],
        Rate: []
      }
      let param = {
        orgId: sessionStorage.getItem('roleData')
      }
      this.$store.dispatch('HomePage/GET_GETCARWORKRATE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            res.data.data.map(item => {
              carRateObj.Data.push(item.date)
              carRateObj.Rate.push(item.dayUseRate.split('%')[0])
            })
            this.carRate(carRateObj)
          }
        }
      }).catch(err => { })
    },
    carRate(carRateObj) {
      let option = {
        grid: {
          top: '10%',
          left: '12%',
          right: '3%',
          bottom: '14%'
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            console.log(params)
            return params[0].name + "<br/>" +this.$t('VehicleAnalysis.form.vehicleWorkingRate') + ' : ' + params[0].value + ' % '
          },
        },
        xAxis: {
          type: 'category',
          axisTick: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#818A98"
            }
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontChart(16)
            },
          },
          data: carRateObj.Data
        },
        yAxis: {
          type: 'value',
          axisTick: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            formatter: "{value} %",
            color: "#fff",
            fontSize: fontChart(16)
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(173,177,195,.1)"],
              type: "dashed",
            },
          },
        },
        series: [
          {
            data: carRateObj.Rate,
            type: 'line',
            symbol: 'circle',
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: '#01EAFF',
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(0,106,250,0.4)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,106,250,0.4)',
                    },
                  ],
                  false
                ),
              }
            },
          }
        ]
      };
      this.carRateOption = option
    },

    getCheck() {
      let checkObj = {
        Data: [],
        Rate: []
      }
      let param = {
        orgId: sessionStorage.getItem('roleData')
      }
      this.$store.dispatch('HomePage/GET_GETCARSPOTCHECKRATE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            res.data.data.map(item => {
              checkObj.Data.push(item.date)
              checkObj.Rate.push(item.spotCheckRate)
            })
            this.check(checkObj)
          }
        }
      }).catch(err => { })
    },
    check(checkObj) {
      let option = {
        grid: {
          top: '10%',
          left: '12%',
          right: '3%',
          bottom: '14%'
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            console.log(params)
            return params[0].name + "<br/>" +this.$t('VehicleAnalysis.form.checkPassRate') + ' : ' + params[0].value + ' % '
          },
        },
        xAxis: {
          type: 'category',
          axisTick: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#818A98"
            }
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontChart(16)
            },
          },
          data: checkObj.Data
        },
        yAxis: {
          type: 'value',
          axisTick: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            formatter: "{value} %",
            color: "#fff",
            fontSize: fontChart(16)
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(173,177,195,.1)"],
              type: "dashed",
            },
          },
        },
        series: [
          {
            data: checkObj.Rate,
            type: 'line',
            symbol: 'circle',
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: '#01EAFF',
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(0,106,250,0.4)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,106,250,0.4)',
                    },
                  ],
                  false
                ),
              }
            },
          }
        ]
      };
      this.checkOption = option
    },

    changeBtn(index) {
      console.log(1111)
      if (index == 0) {
        this.selectType = 0
        this.getMapData()
      } else if (index == 1) {
        this.selectType = 1
        this.getMapData()
      } else {
        this.selectType = 2
        this.getMapData()
      }
      this.changeBackground = index
    },

    getMapData() {
      let param = {
        orgId: sessionStorage.getItem('roleData'),
        selectType: this.selectType
      }
      this.$store.dispatch('HomePage/GET_GETCARDISTRIBUTIONSTATE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.data = res.data.data
            this.getMap(this.data)
          }
        }
      }).catch(err => { })
    },
    getMap(data) {
      var uploadedDataURL = '/mapData.json';

      let myChart = echarts.init(document.getElementById("mapBargraph"));
      myChart.showLoading();
      $.getJSON(uploadedDataURL, function (geoJson) {
        echarts.registerMap('QPQ', geoJson);
        myChart.hideLoading();
        let Data = []
        data.map(item => {
          if (item.currentState === 0) {
            Data.push({
              value: [item.longitude, item.latitude], itemStyle: { color: '#01EAFF' }
            })
          } else if (item.currentState === 1) {
            Data.push({
              value: [item.longitude, item.latitude], itemStyle: { color: '#FF9900' }
            })
          } else {
            Data.push({
              value: [item.longitude, item.latitude], itemStyle: { color: '#E60012' }
            })
          }
        })

        let option = {
          visualMap: {
            show: false,
            min: 0,
            max: 500,
            left: 'left',
            top: 'bottom',
            text: [this.$t('VehicleAnalysis.high'), this.$t('VehicleAnalysis.low')], 
            calculable: true,
            seriesIndex: [1],
            inRange: {},
          },
          geo: [
            {
              map: 'QPQ',
              aspectScale: 0.75,
              roam: false, 
              layoutSize: '95%',
              layoutCenter: ['50%', '50%'],
              itemStyle: {
                borderColor: '#00ffff',
                borderWidth: fontChart(5),
                areaColor: 'transparent',
              },
              emphasis: {
                itemStyle: {
                  areaColor: 'transparent',
                },
                label: {
                  show: false,
                },
              },
              zlevel: -1,
            },
            {
              type: "map",
              map: "QPQ",
              zlevel: -2,
              aspectScale: 0.75,
              layoutCenter: ["50%", "51.5%"],
              layoutSize: "95%",
              roam: false,
              silent: true,
              itemStyle: {
                normal: {
                  borderWidth: fontChart(2),
                  borderColor: "#08b6c6",
                  shadowColor: "rgba(0, 240, 255, .4)",
                  shadowOffsetY: fontChart(5),
                  shadowBlur: fontChart(15),
                  areaColor: "transparent",
                },
              },
            },
            {
              type: "map",
              map: "QPQ",
              zlevel: -3,
              aspectScale: 0.75,
              layoutCenter: ["50%", "50%"],
              layoutSize: "95%",
              roam: false,
              silent: true,
              itemStyle: {
                normal: {
                  borderWidth: fontChart(5),
                  borderColor: "rgba(5,9,57,0.8)",
                  shadowColor: "rgba(0, 240, 255, .4)",
                  shadowOffsetY: fontChart(15),
                  shadowBlur: fontChart(10),
                  areaColor: "transparent",
                },
              },
            }
          ],
          series: [
            {
              name:this.$t('VehicleAnalysis.qingPuArea'),
              type: 'map',
              mapType: 'QPQ',
              label: {
                normal: {
                  textStyle: {
                    fontSize: fontChart(15),
                    fontWeight: 'bold',
                    color: '#fff',
                  },
                },
              },
              aspectScale: 0.75,
              layoutSize: '95%',
              layoutCenter: ['50%', '50%'],
              zoom: 1,
              itemStyle: {
                normal: {
                  label: { show: false },
                  borderWidth: fontChart(2),
                  borderColor: '#103e7b',
                  areaColor: '#092750',
                },
                emphasis: {
                  label: { show: false },
                  areaColor: '#092750',
                },
              },
            },
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              rippleEffect: {
                brushType: 'stroke'
              },
              showEffectOn: 'render',
              legendHoverLink: true,
              symbol: 'circle',
              symbolSize: fontChart(16),
              label: {
                show: false,
              },
              itemStyle: {
                normal: {

                },
                emphasis: {
                  label: { show: false },
                },
              },
              data: Data,
              hoverAnimation: true,
              zlevel: 1,
            },
          ],
        };
        myChart.setOption(option);
      });

    },
  },
};
